import React, { useCallback, useEffect, useState } from 'react';
import { Button, Container, SearchInput } from '../../../components';
import ProductGroupTable from './ProductGroupTable';
import { IoMdAdd } from 'react-icons/io';
import {
  ModalProvider,
  useModal,
} from '../../../components/common/modal/ModalContext';
import CreateProductGroup from './CreateProductGroup';
import { useProductGroup } from '../../../context/ProductGroupContext/ProductGroupContextProvider';
import { useDebouncedCallback } from '@/utils/useDebouncedCallback';

const ProductGroupView = () => {
  const [inputValue, setInputValue] = useState('');
  const { openModal, closeModal } = useModal();
  const { searchQuery, setSearchQuery, clearFormData, setCurrentPage } =
    useProductGroup();

  const handleOpenModal = useCallback(() => {
    clearFormData();
    openModal(
      <CreateProductGroup closeModal={closeModal} />,
      'Create Product Group',
    );
  }, [clearFormData, openModal, closeModal]);

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchQuery(value);
    },
    [setSearchQuery],
  );

  const debouncedSetSearchQuery = useDebouncedCallback((val) => {
    setSearchQuery(val);
    setCurrentPage(0);
  }, 300);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    debouncedSetSearchQuery.call(val);
  };

  useEffect(() => {
    setCurrentPage('0');
  }, [searchQuery]);

  return (
    <Container title="Product Group">
      <div className="lg:flex justify-end mx-5 lg:gap-5 gap-2 mt-3 ">
        <SearchInput
          value={inputValue}
          onChange={handleSearchChange}
          onSearchClick={handleSearch}
        />
        <div className="lg:mt-0 flex justify-center mt-2">
          <Button onClick={handleOpenModal}>
            <div>Add Product Group</div>
            <div>
              <IoMdAdd />
            </div>
          </Button>
        </div>
      </div>
      <ProductGroupTable />
    </Container>
  );
};

const App = () => (
  <ModalProvider>
    <ProductGroupView />
  </ModalProvider>
);

export default App;
